import { useState, useEffect } from "react";
import {Col, Container, Row } from "react-bootstrap";
import { ArrowRightCircle } from "react-bootstrap-icons";
import headerImg from "../assets/img/header-img.svg"

export const Banner = () => {
    const [loopNum, setLoopNum] = useState(0);
    const [isDeleting, setDeleting] = useState(false)
    const toRotate =[ "Felipe", "Software Engineer", "Backend Developer", "Web Developer" ];
    const [text, setText] = useState('');
    const [delta, setDelta] = useState(300 - Math.random() * 100);
    const period = 2000;

    useEffect(() => {
        let ticker = setInterval(() =>{
            tick()
        },delta)

        return () => {clearInterval(ticker);}
    }, [text])

    const tick = () => {
        let i = loopNum % toRotate.length;
        let fullText = toRotate[i];
        let updatedText = isDeleting ? fullText.substring(0, text.length - 1) : fullText.substring(0, text.length + 1);

        setText(updatedText);

        if (isDeleting) {
            setDelta(prevDelta => {
                return prevDelta / 2;
            })
        }

        if (!isDeleting && updatedText === fullText) {
            setDeleting(true);
            setDelta(period)
        }else if (isDeleting && updatedText === '') {
            setDeleting(false);
            setLoopNum(loopNum + 1);
            setDelta(500)
        }
    }

     return (
      <section className="banner" id="home">
        <Container>
            <Row className="align-items-center">
                <Col xs={12} md={6} xl={7}>
                    <span className="tagline">
                        Wellcome to my Portfolio
                    </span>
                    <h1>
                        {`Hi I'm `}<span className="wrap" >{text}</span>
                        <br/>
                        <p>
                            I build software solutions with a focus on clarity, efficiency, and continuous improvement. I enjoy learning new technologies, exploring different approaches, and turning ideas into practical, well-structured results. My goal is to grow consistently, contribute to meaningful projects, and create solutions that deliver real value.
                        </p>

                        <button onClick={() => {
                            console.log('connect');
                            window.location.href = '#connect'; // Isso leva o usuário para a seção
                        }}>Let's connect <ArrowRightCircle size={25}/> </button>

                    </h1>
                </Col>
                <Col xs={12} md={6} xl={5}>
                    <img src={headerImg} alt="Headder Img"/>
                </Col>
            </Row>
        </Container>
      </section>
     )
}